import React from "react";
import './clicker-testing.scss';
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants } from "../../../../constants/constants";
import Dropdown from '../../../common/dropdown-v2/dropdown';
import SchoolApi from "../../../../apis/school";
import StudentClickerList from "./student-clicker-list/student-clicker-list";
import CommonUtils from "../../../../utility/common-utilities";

class ClickerTesting extends React.Component {

    state = {
        clickerSetDropdown: [],
        clickerUserList: [],
        showStudentClickerList: false,
        setName: ""
    }


    constructor(props) {
        super(props)
        console.log(this.props.selectedItem)
    }

    componentDidMount() {
        if (this.props.selectedItem.clickerSet && this.props.selectedItem.clickerSet.length && this.props.selectedItem.clickerSet && this.props.selectedItem.clickerSet.length === 1) {
            this.onSelectDropDown(this.props.selectedItem.clickerSet[0], "selectedSetId")
        } else {
            this.setState({clickerSetDropdown : this.props.selectedItem.clickerSet && this.props.selectedItem.clickerSet.length ? this.props.selectedItem.clickerSet : []})
        }
    }



    onClickBack() {
        this.props.delegate && this.props.delegate.hideTestClickerScreen && this.props.delegate.hideTestClickerScreen()
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props?.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props?.selectedItem?.section || ""} >`}</span>
                {
                    this.props.selectedItem.type === 'CLICKER_ASSESSMENT' ?
                        <span className='pl-2'>{this.getChapterNames(this.props.selectedItem?.chapters)} {`>`}</span>
                        :
                        <span className='pl-2'>{`${this.props?.selectedItem?.chapter} >`}</span>
                }
                {
                    CommonUtils.isOnline() ?
                        <span className='pl-2'>{this.getDate(this.props?.selectedItem?.createdDateTimestamp)}</span>
                        :
                        <span className='pl-2'>{this.props?.selectedItem?.createdDateTimestamp ? this.props?.selectedItem?.createdDateTimestamp : this.props?.selectedItem.createdDate ? this.props?.selectedItem.createdDate : ''}</span>
                }
            </div>
        )
    }

    onSelectDropDown(option, key) {
        console.log(option)
        this.setState({ [key]: option?.value, setName: option?.title }, () => {
            this.getUserClickerList(option)
        })
    }

    getUserClickerList(option) {
        let payload = {
            selectedSetId: this.state.selectedSetId,
            homeworkId: this.props.selectedItem._id
        }

        if (CommonUtils.isOnline()) {
            SchoolApi.getUserClickerList(payload).then(res => {
                this.setState({ showStudentClickerList: true, clickerUserList: res.clickerUserList })
            }).catch(err => {
                console.log(err)
            })
        } else if (!CommonUtils.isOnline()) {

            let studentClickerList = option.studentClickerList

            let studentClickerListhash = {}

            for (let i = 0; i < studentClickerList.length; i++) {
                studentClickerListhash[i + 1] = studentClickerList[i]
            }

            let studentList = this.props.studentList

            let newStudentListWithMacId = []

            studentList.forEach(item => {
                if (item.isTeacher) {
                    item.userDeviceMacId = option.teacherClickerId.deviceMacId
                    newStudentListWithMacId.push(item)
                } else if (studentClickerListhash[item.studentNumber] && studentClickerListhash[item.studentNumber].deviceMacId) {
                    item.userDeviceMacId = studentClickerListhash[item.studentNumber].deviceMacId
                    newStudentListWithMacId.push(item)
                }
            })

            this.setState({ showStudentClickerList: true, clickerUserList: newStudentListWithMacId })
        }
    }

    hideStudentClickerList() {
        this.setState({ showStudentClickerList: false, clickerUserList: [] })
    }






    render() {

        if (this.state.showStudentClickerList) {
            return <StudentClickerList
                delegate={this}
                clickerUserList={this.state.clickerUserList}
                setName={this.state.setName}
                selectedSetId= {this.state.selectedSetId}
                selectedItem={this.props.selectedItem} />
        }



        return (
            <div className="clicker-testing">
                <div className='mb-3 item1'>
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>

                <div className='d-flex align-items-center justify-content-between header-report-card mb-1'>
                    <div className='d-flex align-items-center'>
                        <div>
                            <img className='circle-image' src={getImageSource(ImageConstants.RECOMMENDATION_REPORT_CIRCLE)} />
                        </div>
                        <div className='ml-2'>
                            <div className=''>
                                <span className='screen-title-1'>Test Clickers</span>
                                <span>{this.renderBreadcrumb()}</span>
                            </div>
                        </div>
                    </div>
                </div>


                {
                    this.state.clickerSetDropdown.length ?
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="filter-input-label">
                                    Select a Clicker Set to Test<span className='text-danger'>*</span>
                                </div>
                                <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                    {!this.state.reloadDropdown ?
                                        <Dropdown
                                            placeholder='Select a Set'
                                            options={this.state.clickerSetDropdown}
                                            onSelect={(option) => this.onSelectDropDown(option, "selectedSetId")}
                                            text={"title"}
                                            value={this.state.selectedSetId}
                                        // disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                        >
                                        </Dropdown> : ''
                                    }
                                </div>
                                {this.props.isCreate && !this.state.selectedChapterKey ? <div className='error-text text-danger'>Please Select a Chapter</div> : ''}
                            </div>
                        </div>
                        :
                        <div>No Clickers Found</div>
                }



            </div>
        )
    }

}

export default ClickerTesting;